// cookies.ts

/**
 * Obtém um cookie pelo nome.
 * @param name Nome do cookie
 * @returns Valor do cookie ou `null` se não encontrado
 */
export function getCookie(name: string): string | null {
  const cookies = document.cookie.split(";"); // Divide os cookies em um array
  const prefix = `${name}=`; // Prefixo do cookie a ser procurado

  for (let cookie of cookies) {
    cookie = cookie.trim(); // Remove espaços em branco
    if (cookie.startsWith(prefix)) {
      return cookie.substring(prefix.length);
    }
  }

  return null;
}

/**
 * Define um cookie com nome, valor e expiração em dias.
 * @param name Nome do cookie
 * @param value Valor do cookie
 * @param days Número de dias para expiração
 */
export function setCookie(name: string, value: string, days: number): void {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
}
